import { Link } from "react-router-dom";
import LazyImage from "./ui/LazyImage";
import CategoryIcon from "./CatIconMapper";
import Logo from "../assets/images/Base-pic.png";

type Props = {
  categories?: any[];
  activeId?: string;
};

export default function OtherSiteIdentity({ categories, activeId }: Props) {
  const displayCategories = categories ?? [];
  const half = Math.ceil(displayCategories.length / 2);
  const renderItem = (category: any, index: number) => {
    const isActive = String(category.id) === String(activeId);

    return (
      <Link
        key={category.id ?? index}
        to={`/services/${category.id}`}
        className="relative xl:flex flex-col items-center space-y-2.5 transition-all duration-300"
      >
        <div
          className={`size-[78px] flex items-center justify-center rounded-[27px] overflow-hidden shadow transition
          ${isActive ? "bg-green-05 text-white scale-105" : "bg-white hover:bg-green-01"}`}
        >
          <CategoryIcon
            id={category.id}
            className={`size-[26px] text-green-05 transition
          ${isActive ? "bg-green-05 text-white scale-105" : "hover:bg-green-01"}`}
          />
        </div>

        <span
          className={`absolute top-[72px] text-[12px] text-center transition
          ${isActive ? "text-green-05 font-bold" : "text-green-04"}`}
        >
          {category.name}
        </span>
      </Link>
    );
  };

  return (
    <div className="hidden xl:flex items-center justify-center w-full">
      <div className="flex items-center justify-center gap-x-3 2xl:gap-x-10 w-full flex-wrap">
        {/* LEFT */}
        <div className="flex items-center gap-x-3 2xl:gap-x-10 flex-wrap justify-end">
          {displayCategories.slice(0, half).map(renderItem)}
        </div>

        {/* CENTER */}
        <Link
          to="/founder"
          className="size-14 xl:size-[120px] shrink-0 overflow-hidden rounded-[44px]"
        >
          <LazyImage src={Logo} alt="لوگو" className="object-cover object-top" />
        </Link>

        {/* RIGHT */}
        <div className="flex items-center gap-x-3 2xl:gap-x-10 flex-wrap justify-start">
          {displayCategories.slice(half).map(renderItem)}
        </div>
      </div>
    </div>
  );
}
